// import './App.css';
import Routes from "./routes";
import React, { useEffect } from "react";
import { fetchOrgIcon } from "./api/settingApi";
import { getBaseUrl } from "./utils/apiHelper";
import { setFaviconFromUrl } from "./utils/favicon";

function App() {
  useEffect(() => {
    const run = async () => {
      try {
        const payload = { domain_name: getBaseUrl() };
        const res = await fetchOrgIcon(payload);

        // Adjust this mapping based on your API response shape.
        // Common patterns:
        // - res.data.data.favicon_icon
        // - res.data.data.logo
        // - res.data.favicon
        const org = res?.data?.data || {};

        const faviconPath = org.favicon_icon;

        if (!faviconPath) return;

        // If your favicon is publicly accessible (recommended):
        setFaviconFromUrl(faviconPath);

        // If your favicon URL needs auth header, use this instead:
        // const token = localStorage.getItem('auth-token');
        // await setFaviconFromProtectedUrl(faviconPath, token ? { Authorization: `Bearer ${token}` } : {});
      } catch (err) {
        // Silently ignore or log—favicon isn't critical
        console.error("Favicon load failed:", err?.message || err);
      }
    };

    run();
  }, []);

  return (
    <>
      <Routes />
    </>
  );
}

export default App;
